import React from 'react';
import styles from './Modal.module.css';
import image1 from '../../images/informativo_boleto/image001.png';
import image2 from '../../images/informativo_boleto/image002.png';
import image3 from '../../images/informativo_boleto/image003.png';
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const ModalBoleto = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // Não renderiza o modal se isOpen for false
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Associados na Modalidade Carnês<br/>Informações sobre Boletos</h2>
          <button 
            className={styles.closeButton} 
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        
        <div className={styles.modalBody}>
          <div className={styles.modalSection}>
            <p className={styles.modalGreeting}>Prezado(a) Associado(a),</p>
            
            <div className={styles.infoCard}>
              <p className={styles.modalText}>
                Informamos que para sua melhor comodidade, a partir do 2º trimestre de 2025, os <br/>
                boletos serão enviados por e-mail.
              </p>
            </div>

            <div className={styles.infoHighlight}>
              <p className={styles.modalText}>
              Lembrando que as parcelas do seu Plano de Pecúlio, vencem até o dia 15 de cada mês. <br/>
Caso precise da 2ª via do boleto, favor nos contactar através dos seguintes canais de <br/>
atendimento: Fone: (54) 3221-2777, WhatsApp: (54) 99225-3483 ou por <br/>
e-mail: <a href="mailto:scms@scmsprevidencia.com.br">scms@scmsprevidencia.com.br</a>
              </p>
            </div>
          </div>

          <div className={styles.modalSection}>
            <div className={styles.contactCard}>
              <h3 className={styles.sectionTitle}>Canais de Atendimento</h3>
              <p className={styles.modalText}>
                Para solicitar 2ª via do boleto:
              </p>
              <ul className={styles.contactList}>
                <li>
                  <FaPhone className={styles.contactIcon} />
                  Telefone: <span className={styles.contactDetail}>(54) 3221-2777</span>
                </li>
                <li>
                  <FaWhatsapp className={styles.contactIcon} />
                  WhatsApp: <span className={styles.contactDetail}>(54) 9 9225-3483</span>
                </li>
                <li>
                  <FaEnvelope className={styles.contactIcon} />
                  E-mail: <a href="mailto:scms@scmsprevidencia.com.br" className={styles.modalLink}>
                    scms@scmsprevidencia.com.br
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.modalSection}>
            <h3 className={styles.sectionTitle}>Pagamento via DDA</h3>
            
            <div className={styles.infoCard}>
              <p className={styles.modalText}>
                Os associados que têm contratado junto ao seu banco, o serviço <strong>DDA:</strong> Débito Direto <br/>
                Autorizado feito via conta bancária, vão observar o seguinte:
              </p>
              
              <div className={styles.stepsContainer}>
                <h4 className={styles.stepTitle}>Exemplo de pagamento:</h4>
                <ol className={styles.stepsList}>
                  <li>Pagamento <span className={styles.highlight}>abril</span> <bold>DDA</bold> direto,</li>
                  <li>Demais meses <span className={styles.highlight}>maio</span> e <span className={styles.highlight}>junho</span> tela do banco <bold>DDA</bold> dos <span className={styles.highlight}>meses subsequentes.</span></li>
                </ol>
              </div>

              <p className={styles.modalText}>
                Acesse seu banco e clique no Menu Pagamentos:
              </p>
            </div>

            <div className={styles.imageGallery}>
              <div className={styles.galleryColumn}>
                <img src={image1} alt="Menu Pagamentos" className={styles.modalImage} />
                <img src={image2} alt="Seleção de DDA" className={styles.modalImage} />
                <img src={image3} alt="Confirmação de pagamento" className={styles.modalImage} />
              </div>
            </div>
          </div>

          <div className={styles.modalFooter}>
            <p className={styles.modalText}>
              Qualquer dúvida, estamos à disposição para auxiliar.
            </p>
            <p className={styles.modalText}>Agradecemos sua preferência.</p>
            
            <div className={styles.signature}>
              <p>Atenciosamente,</p>
              <p className={styles.companyName}>SCMS – Sociedade Caxiense de Mútuo Socorro</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ModalBoleto;
